<template>
  <div class="advertise-card">
    <div class="card-header">
      <div class="logo-section">
        <div class="logo-icon">
          <img :src="home1_yinliu_logo" alt="FBM">
        </div>
        <div class="title-info">
          <h3 class="title">{{ productName }}</h3>
          <p class="subtitle">Pinjaman Online OJK</p>
        </div>
      </div>
      <span class="tag">iklan</span>
    </div>

    <div class="card-content">
      <div class="loan-info">
        <p class="label">Jumlah Pinjaman</p>
        <h2 class="amount">Rp8.000.000</h2>
        <p class="label">Bunga Pinjaman</p>
        <p class="rate">0.024%</p>
      </div>
      <div class="action-section">
        <a :href="downloadUrl">
          <button class="apply-btn">Ajukan Sekarang</button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import trafficConfig from '@/mixins/trafficConfig'
export default {
  mixins: [trafficConfig],
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="less">
.advertise-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-top: 100px;
  margin-bottom: 150px;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 32px;

    .logo-section {
      display: flex;
      align-items: center;
      gap: 16px;

      .logo-icon {
        width: 90px;
        height: 90px;
        border-radius: 21px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #eeeeee;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .title-info {
        .title {
          font-size: 32px;
          font-weight: 600;
          color: #333333;
          margin: 0 0 4px 0;
        }

        .subtitle {
          font-size: 24px;
          color: #999999;
          margin: 0;
        }
      }
    }

    .tag {
      background: #cccccc;
      color: #ffffff;
      font-size: 24px;
      padding: 4px 12px;
      border-radius: 12px;
      font-weight: 700;
    }
  }

  .card-content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .loan-info {
      flex: 1;

      .label {
        font-size: 24px;
        color: #999999;
        margin: 0 0 4px 0;
      }

      .amount {
        font-size: 36px;
        font-weight: 700;
        color: #333333;
        margin: 0 0 12px 0;
      }

      .rate {
        font-size: 26px;
        font-weight: 600;
        color: #333333;
        margin: 4px 0 0 0;
      }
    }

    .action-section {
      .apply-btn {
        background: #ffc107;
        color: #ffffff;
        font-size: 28px;
        font-weight: 600;
        padding: 12px 24px;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        white-space: nowrap;

        &:hover {
          background: #ffb300;
        }

        &:active {
          background: #ffa000;
        }
      }
    }
  }
}
</style>
